// libs
import * as React from 'react'
import { useLocation } from 'react-router-dom'

// components
import { Auth } from 'src/components/authentication/auth/auth'

// helpers
import { parseQueryString } from 'src/utils/url/url'

const ResetPassword: React.FC = () => {
  const location = useLocation()
  const params = parseQueryString<string, { token: string; email: string }>(
    location.search,
    ['token', 'email']
  )

  return (
    <Auth
      closeModal={() => undefined}
      closeable={false}
      initialView="reset-password"
      resetToken={params.token}
      resetEmail={params.email}
    />
  )
}

export default ResetPassword
